import React, { useState } from 'react';
import { Button, ModalProps } from 'antd';
import CommonModal from '../../../../components/Modals/CommonModal';
import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../../../store/app';
import { deletePortTimeRequest } from '../../../../store/SendMessageSlice';

interface DeleteModalProps extends ModalProps {
  title?: string;
  close: any;
  open: boolean;
  deleteValues: any;
  name?: string | number;
  getInquireList: any;
}

const DeleteRequest: React.FC<DeleteModalProps> = ({
  title,
  close,
  open,
  deleteValues,
  name,
  getInquireList,
}) => {
  const dispatch: AppDispatch = useDispatch();
  const [saving, setSaving] = useState<boolean>(false);

  const deleteProduct = () => {
    setSaving(true);

    dispatch(deletePortTimeRequest(deleteValues))
      .then(() => {
        // if (!data.status) {
        //   form.setFields(data.error);
        // } else {
        close();
        getInquireList();
        // }
      })
      .catch(() => {
        // if (!data.status) {
        //   form.setFields(data.error);
        // } else {
        close();
        // }
      })
      .finally(() => setSaving(false));
  };

  return deleteValues ? (
    <CommonModal
      className='deleteModal'
      title={`Delete ${title}`}
      open={open ? true : false}
      onCancel={close}
      footer={[
        <Button key='2' htmlType='button' className='EditBtn' onClick={close}>
          Cancel
        </Button>,
        <Button
          key='1'
          htmlType='button'
          type='primary'
          className='cancelBtn'
          loading={saving}
          onClick={deleteProduct}>
          Delete
        </Button>,
      ]}>
      <div className='deleteNote'>
        Are you sure want to delete
        <br />
        <strong>
          {name && <span>{name}:</span>} {title}
        </strong>
        ?
      </div>
    </CommonModal>
  ) : (
    <></>
  );
};
export default DeleteRequest;
